import React, { useEffect, useState, useRef } from 'react';
import useApp from 'hooks/useApp'
import { Button, LayerBottom, Layer } from 'components'
import styles from './index.module.css'
import { useSetRecoilState, useRecoilState } from 'recoil'
import layerStyles from 'css/Layer.module.css'
import { showAlertState } from 'states/headerState'
import { showAlarmLayerState, moreAlertPost } from 'views/setting/states'
import AlarmSetting from 'views/setting/AlarmSetting'
import { useNavigate } from 'react-router-dom'

import Lib from 'library';

const Alert = () => {


	const App = useApp()
	const navigate = useNavigate()

	const [showAlert, setShowAlert] = useRecoilState(showAlertState)
	const [showAlarmLayer, setShowAlarmLayer] = useRecoilState(showAlarmLayerState) //알림설정

	const [alarmList, setAlarmList] = useState()
	const [notiLength, setNotiLength] = useState()
	const [notiCount, setNotiCount] = useState()
	const [test, setTest] = useState()

	const isLoading = useRef(false)
	const noMore = useRef(false)
	const [morePage, setMorePage] = useRecoilState(moreAlertPost);
	const [rowsPerPage, setRowsPerPage] = useState(20)	//페이지당 로우 수
	const layerWin = useRef()
	const page = useRef(1)
	// 연동받은 기관이 있는 지 조회한다.
	const [aplyMydata, setAplyMydata] = useState()

	const openLayer = () => {
		App.confirm({
			msg: "알림내역을 모두 삭제할까요?",
			onOk: deleteAll,
			ok: "예",
			cancel: "아니요",
			type: "bottom"
		})
	}

	// 알림 개별 읽음
	const onListClick = (id, notiTpCd, title) => {
		Lib.post(`/api/noti/upd/read/${id}`, {
			mbId: App.user?.mbId,
			notiSno: id
		}, data => {
			setAlarmList(data => {
				return data.map(item => {
					if (item.notiSno === id) item.readYn = "Y"
					return item
				})
			})
		})

		//알림 url 이동
		App.closeAllLayers()
		switch (notiTpCd) {
			case "INFL_CHG": //인플루언서
				navigate("/home/participate")
				break
			case "DAILY_RPRT": //데일리리포트
				if(aplyMydata){
					navigate("/home/report")
				} else {
					navigate("/home/reportIntro")
				}
				break
			case "DATA_LINK":
				if (title === "데이터 연동") { //데이터 연동
					navigate("/data")
					break
				} else { //데이터 영수증
					navigate("/mydata/dataReceipt")
					break
				}
			case "PAY_SCHDL": //마이데이터
				navigate("/mydata")
				break
			default:
				navigate("/mydata")
				break

		}
	}

	// 모두 읽음
	const readAll = () => {
		Lib.post(`/api/noti/upd/read`, result => {
			setAlarmList(data => {
				if (!data) return
				return data.map(item => {
					item.readYn = "Y"
					return item
				})
			})
		})
	}

	//설정중인 알림 조회
	const getNotiLength = () => {
		Lib.post(`/api/setting/noti/config`, data => {
			setNotiLength(data)
		})
	}

	//알림 전체삭제
	const deleteAll = () => {
		Lib.post(`/api/noti/del`, result => {
			setAlarmList([])
		})
	}

	useEffect(() => {
		if (!notiLength) return

		let count = 0
		for (let o in notiLength) {
			if (notiLength[o] === "Y") count++
		}
		setNotiCount(count)
	}, [notiLength])

	useEffect(() => {
		if (showAlert === true) {
			bindScroll()
			getNoti(morePage)
			getNotiLength()
			noMore.current = false
			Lib.get(`/api/data/lnkup/chck`, data => {
				setAplyMydata(data.hasLnkupData)
			})
		} else if (showAlert === false) {
			// noMore.current = false
			setMorePage(1)
		}
	}, [showAlert])

	useEffect(() => {
		if (showAlert === true) {
			if (showAlarmLayer === false) {
				getNotiLength()
			}
		}
	}, [showAlarmLayer])


	//알림 데이터 api 호출
	const getNoti = (morePage) => {
		if (noMore.current) return
		isLoading.current = true
		if (typeof morePage !== "undefined") page.current = morePage
		Lib.get(`/api/noti`, {
			rowsPerPage: rowsPerPage,
			pageNo: typeof morePage !== "undefined" ? morePage : page.current
		}, data => {
			isLoading.current = false
			if (morePage > 1) {
				if (data.length < rowsPerPage) noMore.current = true
				setAlarmList(prevState => [
					...prevState,
					...data
				]);
			} else {
				setAlarmList(data)
				if (data.length < rowsPerPage) noMore.current = true
			}
		})
	}

	const bindScroll = () => {
		const layerWrap = layerWin.current.querySelector(`.${layerStyles.wrap}`)
		const wrapPadding = layerWin.current.querySelector(`#wrapPadding`)
		const screenHeight = window.screen ? window.screen.height : window.innerHeight

		if (layerWrap) {
			layerWrap.addEventListener("scroll", e => {
				if (noMore.current) return
				const scrollTop = layerWrap.scrollTop
				const rect = wrapPadding.getBoundingClientRect()
				const top = rect.top
				const height = rect.height
				if (((height + top) - screenHeight) <= scrollTop) {
					if (!isLoading.current) setMorePage(prevStus => prevStus + 1);
				}
			})
		}
	}

	useEffect(() => {
		if (showAlert === true) {
			getNoti(morePage)
		}
	}, [morePage])

	return (
		<Layer show={showAlert} closeLayer={() => setShowAlert(false)} title="알림" ref={layerWin}>
			<div className="page">
				<div className="padding pt_10" >
					<div className="flex-justify_between align_center">
						<h3>알림</h3>
						{alarmList &&
							alarmList.length > 0 &&
							<div className="link-top flex-align_center">
								<span onClick={readAll}>모두읽음</span>
								<span className="text-red ml_20" onClick={openLayer}>전체삭제</span>
							</div>
						}
					</div>
					<div className={`${styles["alert-title"]} mt_20`} onClick={() => setShowAlarmLayer(true)}>
						<h4>설정중인 알림 <strong className="text-blue">{notiCount}</strong></h4>
						<i className="icon icon_arrow_sm right icon_arrow_md" />
					</div>
				</div>
				<div id="wrapPadding">
					{/* <ul className={styles["alert-list"]}> */}

					{alarmList &&
						alarmList.length > 0 &&
						alarmList.map((data, index) => {
							if (data.notiTitle === "데이터 연동") {
								data.icd = 22
							} else if (data.notiTitle === "데이터 영수증") {
								data.icd = 23
							} else if (data.notiTitle === "데일리 리포트") {
								data.icd = 24
							} else if (data.notiTitle === "금융 인플루언서") {
								data.icd = 25
							} else {
								data.icd = 26
							}
							return (
								<ul className={styles["alert-list"]} key={index}>
									<li className={data.readYn === "N" ? styles.new : ""} onClick={() => onListClick(data.notiSno, data.notiTpCd, data.notiTitle)}>
										{/* <i className={`icon icon_menu icon_menu_${data.notiTpCd}`} /> */}
										<i className={`icon icon_menu icon_menu_${data.icd}`} />
										<div className={styles["txt-area"]}>
											<div className={styles.title}>
												<p>{data.notiTitle}</p>
												<span>{data.notiTrnspTm.substr(5, 2)}월 {data.notiTrnspTm.substr(8, 2)}일</span>
											</div>
											<div className={styles.cont}>
												{data.notiConts}
											</div>
										</div>
									</li>
								</ul>
							)
						})
					}
				</div>
				{alarmList &&
					alarmList.length === 0 &&
					<>
						<div className="center-cont">
							<i className="icon icon_no_data" />
							<p className="mt_20">알림 내역이 없습니다.</p>
						</div>
						<div className="flex-shrink_0 padding">
							<div className={styles["guide-box"]}>푸시 알람을 끄면 유용한 정보를 받을 수 없어요!</div>
						</div>
					</>
				}


				{/* </ul> */}

				<AlarmSetting />
			</div>
		</Layer>
	)
}

export default Alert